<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'wresize-panel-2',
})
</script>
<template>
<div class="wresize-panel-2" @mouseup="onMouseup($event)" @mousemove="onMousemove($event)">
    <template v-if="props.fixedWidthMode == 'left'">
        <div class="wresize-panel-left" :style="{width: divLeft.width + 'px'}">
            <slot name="left"></slot>
        </div>

        <div class="wresize-handler" @mousedown="onMouseDownLeft($event)" :style="{left: divHandler.left + 'px'}"></div>

        <div class="wresize-panel-right" :style="{left: divRight.left + 'px'}">
            <slot name="right"></slot>
        </div>
    </template>
    <template v-else>
        <div class="wresize-panel-left" :style="{right: divLeft.right + 'px'}">
            <slot name="left"></slot>
        </div>

        <div class="wresize-handler" @mousedown="onMouseDownRight($event)" :style="{left: divHandler.right + 'px'}"></div>

        <div class="wresize-panel-right" :style="{width: divRight.width + 'px'}">
            <slot name="right"></slot>
        </div>
    </template>
</div>
</template>

<script lang="ts" setup name="wresize-panel-2">
import {ref,defineProps} from 'vue'
var props=defineProps({
        fixedWidth: {
            type: Number,
            default: 200
        },
        fixedWidthMode: { //左边还是右边定宽
            type: String,
            default: "left"
        },
        onResize: {
            type: Function,
            default: undefined
        }
})
var flag= false,
            disx=0,
            divLeft= {
                width: props.fixedWidth,
                right: props.fixedWidth + 5,
                temp: 0,
            },
            divRight= {
                width: props.fixedWidth,
                left: props.fixedWidth + 5,
                temp: 0,
            },
            divHandler= {
                left: props.fixedWidth,
                right: props.fixedWidth,
                temp: 0
            };

function onMouseDownLeft(event) {
             flag = true;
            var dom = event.currentTarget;
            disx = event.pageX;
            divHandler.temp = divHandler.left;
            divLeft.temp = divLeft.width;
            divRight.temp = divRight.left;
        }
function onMouseDownRight(event) {
            flag = true;
            var dom = event.currentTarget;
            disx = event.pageX;
            divHandler.temp = divHandler.right;
            divRight.temp = divRight.width;
            divLeft.temp = divLeft.right;
        }
function onMouseup(event) {
            flag = false;
            if(props.onResize) {
                props.onResize();
            }
        }
function onMousemove(event) {
            if(event.which != 1) {
                if(flag != '') {
                    flag = '';
                }
                return;
            }
            if(!flag) {
                return;
            }
            var dx = event.pageX - disx;
            if (fixedWidthMode == "left") {
                divHandler.left = divHandler.temp + dx;
                divLeft.width = divLeft.temp + dx;
                divRight.left = divRight.temp + dx;
            } else {
                divHandler.right = divHandler.temp - dx;
                divRight.width = divRight.temp - dx;
                divLeft.right = divLeft.temp - dx;
            }
        }
</script>

<style lang="scss">
.wresize-panel-2 {
    position: relative;

    .wresize-panel-left {
        position: absolute;
        left: 0px;
        top: 0px;
        bottom: 0px;
    }

    .wresize-panel-center {
        position: absolute;
        top: 0px;
        bottom: 0px;
    }

    .wresize-panel-right {
        position: absolute;
        right: 0px;
        top: 0px;
        bottom: 0px;
    }

    .wresize-handler {
        position: absolute;
        top: 0px;
        bottom: 0px;
        width: 5px;
        cursor: w-resize;
    }
}
</style>
